import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "@/hooks/use-auth";
import { AppStatusScreen } from "./route-states";

/**
 * Gate for everything behind login.
 *
 * The wait on `isRestoring` is the important part: after a hard reload the
 * access token is gone (it lives in memory) and the app is mid-refresh.
 * Redirecting during that window would bounce an authenticated admin to the
 * login screen on every refresh.
 */
export function ProtectedRoute() {
  const { isAuthenticated, isRestoring } = useAuth();
  const location = useLocation();

  if (isRestoring) return <AppStatusScreen label="Restoring your session…" />;

  if (!isAuthenticated) {
    // `state.from` lets the login screen return the admin to where they were
    // headed instead of always dropping them on the dashboard.
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return <Outlet />;
}

/** Inverse guard: keeps a signed-in admin off the login screen. */
export function PublicOnlyRoute() {
  const { isAuthenticated, isRestoring } = useAuth();

  if (isRestoring) return null;
  if (isAuthenticated) return <Navigate to="/dashboard" replace />;
  return <Outlet />;
}
